// src/api/v3/_auth.js
export function authHeaders() {
  const token =
    localStorage.getItem('bagspa_token') ||
    localStorage.getItem('jwt') ||
    sessionStorage.getItem('jwt');
  return token ? { Authorization: `Bearer ${token}` } : {};
}
